<template>
  <div class="app-body">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" class="query-form">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="$refs.table.reload()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('erp:per:save')" type="primary" @click="addOrUpdateHandle()">{{
              $t('add')
            }}
          </el-button>
        </el-form-item>
      </el-form>
      <SweetTable url="/erp/per/pay/page" delete-url="/erp/per/pay" ref="table">
        <el-table-column prop="orderCode" label="订单编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="receiverName" label="收款公司" header-align="center" align="center"></el-table-column>
        <el-table-column prop="payAmount" label="预付款金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="limitAmount" label="剩余金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="payDate" label="付款时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="payBank" label="付款银行" header-align="center" align="center"></el-table-column>
        <el-table-column prop="payAccount" label="付款账户" header-align="center" align="center"></el-table-column>
        <el-table-column prop="receiverBank" label="收款行" header-align="center" align="center"></el-table-column>
        <el-table-column prop="receiverAccount" label="收款账户" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creatorName" label="制单人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="制单时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('erp:per:update')" type="text" size="small"
                       @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
            </el-button>
            <el-button v-if="$hasPermission('erp:per:delete')" type="text" size="small"
                       @click="$refs.table.doDelete(scope.row)">{{ $t('delete') }}
            </el-button>
          </template>
        </el-table-column>
      </SweetTable>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update  ref="addOrUpdate" @refreshDataList="$refs.table.getDataList()"></add-or-update>
    </div>
</template>

<script>
import AddOrUpdate from './add-or-update'
import SweetTable from '@/mixins/SweetTable'
export default {
  mixins:[SweetTable],
  data () {
    return {
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
